import * as React from "react";
import { Box, Toolbar, Typography } from "@mui/material";
import { PageLayout, NavMenuOption } from "components/PageLayout/PageLayout";
import { JobRequestOrigination } from "gen/clients";
import { PagePath } from "types/PagePath";
import { JobRequestList } from "../components/JobRequestList/JobRequestList";

const ExternalApiJobRequestsPage: React.FC = () => {
  return (
    <PageLayout
      selectedNavMenu={NavMenuOption.EXTERNAL_API_JOB_REQUESTS}
      title={
        <Toolbar disableGutters={true} variant="dense">
          <Box flexGrow={1}>
            <Typography variant="h5" sx={{ mb: 2 }}>
              External API Job Requests
            </Typography>
          </Box>
        </Toolbar>
      }
    >
      <Box px={1} my={1}>
        <JobRequestList
          origination={JobRequestOrigination.EXTERNALAPI}
          getDetailsPagePath={(jobRequestId: string) => `${PagePath.externalApiJobRequests}/${jobRequestId}`}
          showCompanyName={true}
          hideArchiveAction={true}
          hideDeleteAction={true}
        />
      </Box>
    </PageLayout>
  );
};

export { ExternalApiJobRequestsPage };
